.container {
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: var(--spacing-md);
  padding-bottom: var(--spacing-xl);
  gap: var(--spacing-md);
}

.header {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
}

.headerIcon {
  font-size: 24px;
  line-height: 1;
}

.headerTitle {
  font-size: var(--font-size-lg);
  font-weight: 600;
  color: var(--tg-theme-text-color);
}

.content {
  background: var(--tg-theme-section-bg-color);
  border-radius: var(--border-radius);
  padding: var(--spacing-lg);
  flex: 1;
}

.text {
  font-size: var(--font-size-md);
  color: var(--tg-theme-text-color);
  line-height: 1.6;
  word-wrap: break-word;
}

.text h3 {
  font-size: var(--font-size-lg);
  font-weight: 600;
  margin: 16px 0 8px;
  color: var(--tg-theme-text-color);
}

.text h3:first-child {
  margin-top: 0;
}

.text p {
  margin: 0 0 8px;
}

.text b {
  font-weight: 600;
}

.text ul {
  margin: 8px 0;
  padding-left: 20px;
}

.text li {
  margin-bottom: 4px;
}

.text pre {
  background: var(--tg-theme-secondary-bg-color);
  border-radius: 8px;
  padding: 12px;
  overflow-x: auto;
  margin: 8px 0;
  font-size: var(--font-size-sm);
}

.text code {
  background: var(--tg-theme-secondary-bg-color);
  border-radius: 4px;
  padding: 2px 6px;
  font-size: 0.9em;
}

.text a {
  color: var(--tg-theme-link-color);
  text-decoration: none;
}

.text a:active {
  opacity: 0.7;
}

.generating {
  display: flex;
  align-items: center;
  gap: var(--spacing-sm);
  color: var(--tg-theme-hint-color);
  font-size: var(--font-size-sm);
  margin-top: var(--spacing-sm);
}

.dots {
  display: inline-flex;
  gap: 3px;
}

.dots span {
  width: 5px;
  height: 5px;
  border-radius: 50%;
  background: var(--tg-theme-hint-color);
  animation: dotPulse 1.2s infinite ease-in-out;
}

.dots span:nth-child(2) {
  animation-delay: 0.2s;
}

.dots span:nth-child(3) {
  animation-delay: 0.4s;
}

@keyframes dotPulse {
  0%, 80%, 100% {
    opacity: 0.3;
    transform: scale(0.8);
  }
  40% {
    opacity: 1;
    transform: scale(1);
  }
}

.errorBox {
  background: var(--tg-theme-section-bg-color);
  border-radius: var(--border-radius);
  padding: var(--spacing-lg);
  text-align: center;
  display: flex;
  flex-direction: column;
  gap: var(--spacing-md);
}

.errorText {
  font-size: var(--font-size-md);
  color: var(--tg-theme-text-color);
}

.backButton {
  width: 100%;
  padding: 12px 16px;
  background: var(--tg-theme-button-color);
  color: var(--tg-theme-button-text-color);
  border: none;
  border-radius: var(--border-radius);
  font-size: var(--font-size-md);
  font-weight: 600;
  cursor: pointer;
  transition: opacity var(--transition-fast);
  -webkit-tap-highlight-color: transparent;
}

.backButton:active {
  opacity: 0.7;
}
